import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ChangeResellerLevelRequestBody } from "./changeResellerLevel.types";

export const requestChangeResellerLevel = async ({
  resellerId,
  ...rest
}: ChangeResellerLevelRequestBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesResellers.Reseller,
      resellerId,
      ApiRoutesResellers.ResellerLevel
    ),
    rest
  );
};
